import React from 'react';
export function TropicalLeaf({
  className,
  style
}: {
  className?: string;
  style?: React.CSSProperties;
}) {
  return <svg viewBox="0 0 100 100" className={className} style={style} fill="currentColor" xmlns="http://www.w3.org/2000/svg" data-id="element-79">
      <path d="M50 95C50 95 20 70 15 45C10 20 30 5 50 5C70 5 90 20 85 45C80 70 50 95 50 95Z" opacity="0.8" data-id="element-80" />
      <path d="M50 95C50 95 35 70 35 45C35 20 45 10 50 10C55 10 65 20 65 45C65 70 50 95 50 95Z" fill="white" opacity="0.1" data-id="element-81" />
      <path d="M50 10V95" stroke="white" strokeWidth="2" strokeLinecap="round" opacity="0.3" data-id="element-82" />
      <path d="M50 30L30 20M50 50L25 40M50 70L35 65M50 30L70 20M50 50L75 40M50 70L65 65" stroke="white" strokeWidth="1.5" strokeLinecap="round" opacity="0.2" data-id="element-83" />
    </svg>;
}